import { withPending, withRejected, withFulFilled } from './commons';
import { GET_REPORT_RAW_PAYLOAD, PREPARE_REPORT_PAYLOAD, CLEAN_REPORT_DATA } from '../actions/report';

const INITIAL_STATE = {
  rawPayload: {
    running: false,
    error: undefined,
    data: undefined,
  },
  processedPayload: {
    running: false,
    error: undefined,
    data: undefined,
  },
};

/**
 * Aguardando a resposta do servidor com os dados
 * de payload
 */
function getReportPayloadWithPending(state, action) {
  const newState = { ...state };
  newState.rawPayload = {
    running: true,
    error: null,
    data: null,
  };
  newState.processedPayload = INITIAL_STATE.processedPayload;

  return newState;
}

/**
 * Resposta recebida, montando o estado com os dados recebidos
 */
function getReportPayloadWithFullFilled(state, action) {
  const newState = { ...state };
  newState.rawPayload = {
    running: false,
    error: null,
    data: action.payload.data,
  };
  newState.processedPayload = INITIAL_STATE.processedPayload;

  return newState;
}

/**
 * Comunicacao com o servidor/provider falhou
 */
function getReportPayloadWithRejected(state, action) {
  const newState = { ...state };
  newState.rawPayload = {
    running: false,
    error: action.payload.response,
    data: action.payload.data,
  };
  newState.processedPayload = INITIAL_STATE.processedPayload;

  return newState;
}

function prepareReportPayloadWithPending(state, action) {
  const newState = { ...state };
  newState.processedPayload = {
    running: true,
    error: null,
    data: null,
  };

  return newState;
}

function prepareReportPayloadWithFullFilled(state, action) {
  const newState = { ...state };
  newState.processedPayload = {
    running: false,
    error: null,
    data: action.payload,
  };

  return newState;
}

/**
 * O pos-processamento do payload falhou. Sem este caso o processedPayload
 * ficava preso em running, o componente nunca era notificado e a modal
 * seguia em carregamento infinito, sem mensagem ao usuario
 */
function prepareReportPayloadWithRejected(state, action) {
  const newState = { ...state };
  newState.processedPayload = {
    running: false,
    error: action.payload,
    data: null,
  };

  return newState;
}

const execute = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  /**
         * GET_REPORT_RAW_PAYLOAD
         */
  case withPending(GET_REPORT_RAW_PAYLOAD):
    return getReportPayloadWithPending(state, action);
  case withFulFilled(GET_REPORT_RAW_PAYLOAD):
    return getReportPayloadWithFullFilled(state, action);
  case withRejected(GET_REPORT_RAW_PAYLOAD):
    return getReportPayloadWithRejected(state, action);


    /**
         * PREPARE_REPORT_PAYLOAD
         */
  case withPending(PREPARE_REPORT_PAYLOAD):
    return prepareReportPayloadWithPending(state, action);
  case withFulFilled(PREPARE_REPORT_PAYLOAD):
    return prepareReportPayloadWithFullFilled(state, action);
  case withRejected(PREPARE_REPORT_PAYLOAD):
    return prepareReportPayloadWithRejected(state, action);

    /**
         * CLEAN
         */
  case CLEAN_REPORT_DATA: return INITIAL_STATE;

  default:
    return state;
  }
};

export default execute;
